export default __webpack_public_path__ + "static/facilities-706b7eff4d9843337701818832e30d10.png";